import React, { useContext } from 'react';
import { LocalizationContext } from '../../../context/localizationContext';
import Styles from './RegisterNewClubInput.module.scss';

const RegisterNewClubInput = (props) => {
  const { handleSerialSearch, setSerialSearched } = props;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { registerNewClub } = localizationState.localization;

  const handleEnterButtonPress = (e) => {
    if (e.charCode === 13 || e.key?.toLowerCase() === 'enter') {
      handleSerialSearch();
    }
  };

  return (
    <div className={Styles.registerClubInput}>
      <div className={Styles.serialInputHeaderText}>
        {registerNewClub.serialNumber}
      </div>
      <label htmlFor="serial-input">{registerNewClub.enterSerial}</label>
      <input
        id="serial-input"
        className={Styles.serialInput}
        onChange={(e) => setSerialSearched(e.target.value)}
        onKeyPress={(e) => handleEnterButtonPress(e)}
      />
    </div>
  );
};

export default RegisterNewClubInput;
